module.exports = __webpack_public_path__ + "img/reintegro.844dc7eb.svg";